import React from 'react'

import QRCode from "qrcode.react";


const QrCode = ({
    value,
    size=256
}) => {
  return (
    <div style={{ height: "auto", margin: "0 auto", 
    maxWidth: size, 
    width: "100%",
    padding:10
     }}>
    <QRCode  id='qr-gen'
    size={size}
    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
    value={value}
    viewBox={`0 0 256 256`}
    />
</div>
  )
}

export default QrCode
